import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseLineHeightOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-line-height-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';

interface ItemLineHeightOptionProps {
  addDelayToOnChange?: boolean;
}

export function ItemLineHeightOption({...props}: ItemLineHeightOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemLeading = useGetKeyFromTextStylesActiveItem('leading');

  if (!activeItem || !('textStyles' in activeItem) || itemLeading === undefined) {
    throw new Error(`Item doesn't have textStyles property`);
  }

  const updateLeadingValue = (leading: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          leading,
        },
      },
      {
        undoable,
      }
    );
  };
  return <ItemBaseLineHeightOption leading={itemLeading} onUpdateLeadingValue={updateLeadingValue} addDelayToOnChange={props.addDelayToOnChange} />;
}
